import axios from 'axios'
import {UrlService} from "@/services/UrlService";
import {
  ADD_EMAIL,
  DELETE_EMAIL,
  EMAIL_BY_ID,
  EMAIL_LISTS,
  KEYS_EMAIL,
  UPDATE_EMAIL,
  UPDATE_EMAIL_MODULE_FEATURE
} from "@/services/ConstantService";
import {GlobalService} from "@/services/GlobalService";
import {AlertService} from "@/services/AlertService";

export const EmailService = {
  async getEmailKeys () {
    return await axios.get(KEYS_EMAIL).then(response => {
      return response.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'GET EMAIL KEYS SERVICE')
      return false
    })
  },
  async getEmailLists(params) {
    let queryString=UrlService.setQueryString(params)
    return await axios.get(EMAIL_LISTS + queryString).then(response => {
      return response.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'GET EMAIL LISTS SERVICE')
      return false
    })
  },
  async addEmail(params) {
    const response = await GlobalService.ajax('post', ADD_EMAIL, params);

    if (!(response.hasOwnProperty('status') && response.status === 200)) {
      AlertService.errorAlert(response.errors.email_address[0], 'CREATION OF NEW EMAIL');
      return {
        result : false,
        id     : null
      };
    }

    return {
      result : true,
      id     : response.data.id
    };
  },
  async deleteEmailById(params) {
    const response = await GlobalService.ajax('delete', DELETE_EMAIL, {params});
    if (!(response.hasOwnProperty('status') && response.status === 200)) {
      AlertService.errorAlert(response.data.message, 'DELETION OF EMAIL');
      return {
        result  : false,
        message : response.data.message
      };
    }

    return {
      result  : true,
      message : response.data.message
    };
  },
  async updateEmailById(params) {
    const emailId = params.email_id;
    delete params.email_id;
    const response = await GlobalService.ajax('put', UPDATE_EMAIL.replace('{email_id}', emailId), params);
    if (!(response.hasOwnProperty('status') && response.status === 200)) {
      if (response.data.errors.email_address) {
        AlertService.errorAlert(response.data.errors.email_address.join('&'), 'UPDATING OF EMAIL');
      } else if (response.data.errors.modules) {
        AlertService.errorAlert(response.data.errors.modules.join('&'), 'UPDATING OF EMAIL');
      }

      return {
        result  : false,
        message : response.data.message
      };
    }

    return {
      result  : true,
      message : response.data.message
    };
  },
  async getEmailById(emailId) {
    const response = await GlobalService.ajax('get', EMAIL_BY_ID.replace('{email_id}', emailId));
    if (!(response.hasOwnProperty('status') && response.status === 200)) {
      AlertService.errorAlert(response.data.message, 'FETCHING EMAIL DETAILS');
      return false
    }
    return response.data;
  },

  async updateEmailModuleFeature(params) {
    const emailId = params.email_id;
    const moduleId = params.module_feature_id;
    delete params.email_id;
    delete params.module_feature_id;

    const response = await GlobalService.ajax('put', UPDATE_EMAIL_MODULE_FEATURE.replace('{email_id}', emailId).replace('{module_feature_id}', moduleId), params);

    if (!(response.hasOwnProperty('status') && response.status === 200)) {
      if (response.data.errors.email_address) {
        AlertService.errorAlert(response.data.errors.email_address.join('&'), 'UPDATING OF EMAIL MODULE FEATURE');
      } else if (response.data.errors.modules) {
        AlertService.errorAlert(response.data.errors.modules.join('&'), 'UPDATING OF EMAIL MODULE FEATURE');
      }

      return {
        result  : false,
        message : response.data.message
      };
    }

    return {
      result  : true
    };
  }

}

export default { EmailService }
